<script lang="ts">import RemoteIcon from "./remote-icon.svelte";
export let size = 20;
</script>

<RemoteIcon icon="SupportChatHomeIcon" {size} color="currentColor" />
